import { useAuth } from "@/hooks/useAuth";
import type { Product } from "@/mocks/products";

function getPriceForUser(product: Product, user: import("@/lib/supabase").Profile | null): number {
  if (!user || user.role === "admin") return product.distributionPrice;
  switch (user.level) {
    case "核心分銷":
      return product.corePrice || product.distributionPrice;
    case "特約經銷":
      return product.dealerPrice || product.distributionPrice;
    case "普通分銷":
      return product.normalPrice || product.distributionPrice;
    default:
      return product.distributionPrice;
  }
}

export function useUserPrice() {
  const { user } = useAuth();

  const getPrice = (product: Product): number => {
    return getPriceForUser(product, user);
  };

  const getProfit = (product: Product): number => {
    return product.suggestedPrice - getPrice(product);
  };

  const getProfitRate = (product: Product): number => {
    const profit = getProfit(product);
    return Math.round((profit / product.suggestedPrice) * 100);
  };

  const levelLabel = user && user.role !== "admin" ? user.level : "核心分銷";

  return { getPrice, getProfit, getProfitRate, levelLabel };
}